import React, {
  Component
}                     from 'react';
import PropTypes      from 'prop-types';
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Tooltip,
  OverlayTrigger,
  Modal
}                     from 'react-bootstrap';
import { withRouter } from 'react-router';
import { connect }    from 'react-redux';
import {
  bindActionCreators,
  compose
}                     from 'redux';
//import Alert          from '../../../components/alert/Alert';
import { createHashHistory } from 'history';
import {
  Breadcrumb as BreadcrumbComponent
}                        from '../../../../components';

// include action file for add merchant
import '../../../../style/subAdmin/SubAdmin.scss';
import { Notification } from '../../../../components/notifications';
import isEmpty from 'lodash.isempty';
import { getDealList, sendTestMail } from '../../../../redux/actions/emailManagerActions';
import {renderAlert, clearAlert} from '../../../../redux/actions/alertsActions';
import DatePicker from 'react-date-picker';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import moment from 'moment';
import loader from '../../../../style/loader/loader.scss'; 
import '../../../../style/react-datetimepicker.scss';

import { getCities } from "../../../../redux/actions/countryCityActions";

import ReactHtmlParser from 'react-html-parser';

import SortableList from './SortableList';

import {SortableContainer, SortableElement, arrayMove} from 'react-sortable-hoc';

import Pagination from 'react-paginating';
const history = createHashHistory();

const HorizontalLine = ({ }) => (
    <hr/>
);

const propTypes = {
    emailOverview: PropTypes.func.isRequired,
};
let cityItems=[];let isLoading="false",  listData = [], dealID = [];
class ListData extends Component {
  constructor(props){

    super(props);
    this.state={
      listData : (this.props.data && this.props.data.listData) ? this.props.data.listData : [],
      dealID : (this.props.data && this.props.data.dealID) ? this.props.data.dealID : [],
      citiesList: [],
      cityId: '',
      dealListError: '',
      totalRecords: 0,
      perPage: 0,
      limit:10,
      currentPage: 1,
      pageCount:0,
      scheduleOnSortIcon: "",
      dealTextSortIcon: "",
      titleSortIcon: "",
      direction: "",
    }
    this.addToList = this.addToList.bind(this);
    this.handleChange=this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  handleDelete = (index) => {
    listData = this.state.listData;
    dealID = this.state.dealID;
    listData.splice(index, 1);
    // listData.map((data, index) =>
    //   dealID.push(data.id)
    // );
    dealID.splice(index, 1);
    this.setState({listData: listData, dealID : dealID});
  }
  
  addToList = (e) => {
    this.setState({dealListError:""})
    listData = this.state.listData;
    dealID = this.state.dealID;
    let id = e.target.attributes.getNamedItem('data-id').value;
    let title = e.target.attributes.getNamedItem('data-title').value;

    dealID.push(id);
    listData.push({id: id, title:title});

    this.setState({dealID: dealID, listData: listData, site_id: localStorage.getItem("siteID")});
  }

  handleSubmit = (e) => {
    e.preventDefault();
    if(this.state.dealID.length > 0){
      this.props.onListSubmit();
      this.props.onListSubmitData(this.state);
    }else{
      this.setState({dealListError:"Please add minimum one deal at your list."});
      window.scrollTo(0, 0);
    }
  }

  handleFilterSubmit(e){
    e.preventDefault();
    let constData = {
      cityID: this.state.cityId,
      emailType: 'multiOffer',
      page:1,
      site_id: localStorage.getItem("siteID")
    }
    this.props.getDealList(constData);
  }

  handleChange(e){
    this.setState({[e.target.name]:e.target.value}) 
  }
  
  handlePageChange = page => {
    isLoading="true";
    this.setState({
      currentPage: page,
    });
    this.props.getDealList({page:page, cityID: this.state.cityId, emailType: 'multiOffer', site_id: localStorage.getItem("siteID")});
  };

  componentWillMount(){
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData && siteData.default_city){
      this.setState({cityId: siteData.default_city});
    }
  }

  componentDidMount(){
    // this.handlePageChange();
    this.props.getCities({site_id: localStorage.getItem("siteID")});
  }

  componentWillReceiveProps(nextProps){
    if(this.props.dealList !== nextProps.dealList){
      if(nextProps.dealList){
        isLoading="false";
        const setPageCount = nextProps.dealList.data.total / nextProps.dealList.data.per_page;
        this.setState({dealList: nextProps.dealList.data.data, totalRecords:nextProps.dealList.data.total, perPage:nextProps.dealList.data.per_page, pageCount:setPageCount})
      }
    }
    
    if (this.props.activecities !== nextProps.activecities) {
      this.setState({ citiesList: nextProps.activecities });
      if(nextProps.activecities && nextProps.activecities[0]){
        this.setState({cityId : nextProps.activecities[0].cityID});
        isLoading =='true'
        // console.log(nextProps.activecities[0].cityID)
        this.props.getDealList({page:this.state.currentPage, site_id: localStorage.getItem("siteID"), cityID: nextProps.activecities[0].cityID, emailType: 'multiOffer'});
      }
    }
  }

  onSortEnd = ({oldIndex, newIndex}) => {
    this.setState({
      listData: arrayMove(this.state.listData, oldIndex, newIndex),
    });
  };

  handleSort = orderBy => e => {
    e.preventDefault();
    let direction;
    const sortIcon = `${orderBy}SortIcon`;
    if (this.state.direction === "") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-up",
        direction: "ASC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "ASC") {
      direction = "DESC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-down",
        direction: "DESC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "DESC") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-up",
        direction: "ASC",
        orderBy: orderBy
      });
    }
    this.props.getDealList({ emailType: 'multiOffer', orderBy: orderBy, direction: direction, limit: this.state.limit, page:1, cityID: this.state.cityId, site_id: localStorage.getItem("siteID") });
  };

  // shouldComponentUpdate(nextProps, nextState) {
  //   if (this.state.dealList === nextState.dealList) {
  //     return false
  //   }
  //   return true
  // }

  render() {
    const { currentPage,totalRecords,perPage,pageCount } = this.state
    return (
      <div className="add-sub-admin">
        {(isLoading =='true') ? 
          <div className="loader">
            <p className="loading-message">
            <i>
                Loading...
            </i>
            </p>
            <div className="spinner">
                <div className="dot1"></div>
                <div className="dot2"></div>
            </div>
          </div> : ''
        }
       
        {/**end contract information **/}
       <form onSubmit={this.handleFilterSubmit}>
        <div className="panel">
          <header className="panel-heading">Multi Offer Campaign</header>
          <div className="panel-body">
            <Row>
              <Col md={3} xs={12}>
                <FormGroup controlId="cityFilter">
                  <ControlLabel>Filter By City</ControlLabel>
                  <FormControl componentClass="select" onChange={this.handleChange} name="cityId" value={this.state.cityId}>
                    <option value="">Select City</option>
                    {this.state.citiesList.length > 0 && this.state.citiesList.map((data, index) => 
                      <option key={index} value={data.cityID}>{data.title}</option>
                      )}
                  </FormControl>
                </FormGroup>
              </Col>
              <Col md={3} xs={12}>
                <ControlLabel style={{'marginTop':'10%'}}>&nbsp;</ControlLabel>
                <Button bsStyle="info" type="submit" id="saveButton" disabled={this.state.disabled}>Submit</Button>
              </Col>
            </Row>
          </div>
        </div> 
        </form> 
        <div className="panel">
          <div className="panel-body">
          {(!isEmpty(this.state.listData)) &&
          <SortableList items={this.state.listData} onSortEnd={this.onSortEnd} handleDelete={this.handleDelete} />
          }
          <table className="table table-hover table-bordered">
            <thead>
              <tr>
                <th>#</th>
                <th onClick={this.handleSort("dealText")}>
                  Offer <span
                    className={this.state.dealTextSortIcon}
                    aria-hidden="true"
                  />
                </th>
                <th onClick={this.handleSort("scheduleOn")}>
                  Scheduled <span
                    className={this.state.scheduleOnSortIcon}
                    aria-hidden="true"
                  />
                </th>
                <th onClick={this.handleSort("title")}>
                  City <span
                    className={this.state.titleSortIcon}
                    aria-hidden="true"
                  />
                </th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
                {(!isEmpty(this.state.dealList)  && this.state.cityID != '') ? 
                  this.state.dealList.map((data, index) => 
                    <tr key={index}>
                      <td>{++index}</td>
                      <td>{data.dealText}</td>
                      <td className={(data.emailManagerID  && data.scheduleOn) ? 'text-success text-center' : 'text-danger text-center'}>{(data.emailManagerID && data.scheduleOn) ? `Scheduled On : ${data.scheduleOn.split(",").map((data, key) => moment(data).format("DD-MM-YYYY HH:mm"))}` : 'Not Yet Scheduled'}</td>
                      <td>{data.title}</td>
                      <td>
                        {(this.state.dealID.indexOf(data.dealID) > -1) ?
                        <Button bsStyle="success" disabled={true} bsSize="xsmall" data-id={data.dealID} data-title={data.dealText} onClick={this.addToList}><i className="fa fa-plus"></i> Add to List</Button>
                        :
                        <Button bsStyle="success" bsSize="xsmall" data-id={data.dealID} data-title={data.dealText} onClick={this.addToList}><i className="fa fa-plus"></i> Add to List</Button>
                        }
                      </td>
                    </tr>
                  )
                :
                <tr><td colSpan="6" className="text-center">Data Not Found</td></tr>
                }
            </tbody>
          </table>
          <div className="text-center">
                <Pagination
                  total={totalRecords}
                  limit={perPage}
                  pageCount={pageCount}
                  currentPage={currentPage}
                >
                  {({
                    pages,
                    currentPage,
                    hasNextPage,
                    hasPreviousPage,
                    previousPage,
                    nextPage,
                    totalPages,
                    getPageItemProps
                  }) => (
                    <div className="pagination">
                      <button
                        {...getPageItemProps({
                          pageValue: 1,
                          onPageChange: this.handlePageChange
                        })}
                      >
                        first
                      </button>

                      {hasPreviousPage && (
                        <button
                          {...getPageItemProps({
                            pageValue: previousPage,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          {'<'}
                        </button>
                      )}

                      {pages.map(page => {
                        let activePage = null;
                        if (currentPage === page) {
                          activePage = { backgroundColor: '#ccc', color: '#666' };
                        }
                        return (
                          <button
                            key={page}
                            style={activePage}
                            {...getPageItemProps({
                              pageValue: page,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            {page}
                          </button>
                        );
                      })}

                      {hasNextPage && (
                        <button
                          {...getPageItemProps({
                            pageValue: nextPage,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          {'>'}
                        </button>
                      )}

                      <button
                        {...getPageItemProps({
                          pageValue: totalPages,
                          onPageChange: this.handlePageChange
                        })}
                      >
                        last
                      </button>
                    </div>
                  )}
                </Pagination>
                </div>

          
          </div>
        </div>


        <Row>
          <Col md={12} xs={12}>
          {/*<Button bsStyle="success">Previous</Button>*/}
          <Button type="submit" bsStyle="success" className="pull-right" onClick={this.handleSubmit}>Save & Continue</Button>
          </Col>
        </Row>
       
       {/*<Row className="BtnRow">
                 <Col md={12} xs={12}>
                   <Button bsStyle="info" type="submit" id="saveButton" disabled={this.state.disabled}>Save</Button>
                   <Button bsStyle="default" onClick={() => history.push(`/contractList`)}>Cancel</Button>
                 </Col>
               </Row>*/}
       
      </div>
    );
  }
}
 
 

const mapStateToProps = (state,ownProps) => {
    return {
      activecities: state.countryCityReducers.activecities,
      sending:  state.emailManagerReducer.sending,
      error: state.emailManagerReducer.error,
      alertType: state.alertsReducer.alertType,
      message: state.alertsReducer.message,
      dealList:  state.emailManagerReducer.dealList,
      testMailStatus: state.emailManagerReducer.testMailStatus,
    };
};

export default compose(
  withRouter, 
  connect(mapStateToProps, {renderAlert, clearAlert, getDealList, sendTestMail, getCities})
)(ListData);



// WEBPACK FOOTER //
// ./src/app/views/admin/EmailManager/multi/ListData.js